module.exports = __webpack_public_path__ + "static/media/album-collection.e7eb8925.svg";